import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/sti-reverse-scan/icon-pod.svg'
import _imports_1 from '@/app/ui/assets/svg/scan-flags/cargo_dg_woodpacking_example.svg'
import _imports_2 from '@/app/ui/assets/svg/scan-cargoV2-badges/success.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-5566521f")

_pushScopeId("data-v-5566521f")
const _hoisted_1 = {
  class: "scan-flags",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "POD HARI INI!"
}
const _hoisted_3 = { class: "scan-flags-row" }
const _hoisted_4 = {
  key: 3,
  class: "text-red-lp-500 text-xl font-semibold"
}
const _hoisted_5 = {
  key: 4,
  class: "px-4 py-2 rounded-full bg-green-lp-100 text-white text-2xl font-bold"
}
const _hoisted_6 = {
  key: 1,
  class: "cargo-flag-image"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "check-circle"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.variant === 'sti')
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          (_ctx.isPod)
            ? (_openBlock(), _createBlock("img", _hoisted_2))
            : _createCommentVNode("", true),
          (_ctx.flags.isDangerousGoods && _ctx.flags.isWoodpacking)
            ? (_openBlock(), _createBlock("img", {
                key: 1,
                src: _ctx.combinedStiAsset,
                alt: _ctx.flagLabel
              }, null, 8, ["src", "alt"]))
            : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                (!_ctx.isPod)
                  ? (_openBlock(), _createBlock("span", {
                      key: 0,
                      class: ['scan-flag-label', _ctx.labelClass]
                    }, _toDisplayString(_ctx.flagLabel), 3))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_3, [
                  _createVNode("img", {
                    src: _ctx.stiAsset,
                    alt: _ctx.isStiDest ? 'STI & STI-DEST' : 'STI'
                  }, null, 8, ["src", "alt"]),
                  (_ctx.isPod)
                    ? (_openBlock(), _createBlock("span", {
                        key: 0,
                        class: ['scan-flag-label', _ctx.labelClass]
                      }, _toDisplayString(_ctx.flagLabel), 3))
                    : _createCommentVNode("", true)
                ])
              ], 64)),
          (_ctx.isOverdue)
            ? (_openBlock(), _createBlock("span", _hoisted_4, "Batas POD Terlewati"))
            : _createCommentVNode("", true),
          (_ctx.regionName)
            ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.regionName), 1))
            : _createCommentVNode("", true)
        ], 64))
      : (_ctx.variant === 'bagging')
        ? (_openBlock(), _createBlock("img", {
            key: 1,
            src: _ctx.baggingAsset,
            alt: _ctx.flagLabel,
            class: "bagging-flag-image"
          }, null, 8, ["src", "alt"]))
        : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
            (_ctx.flags.isDangerousGoods && _ctx.flags.isWoodpacking)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _imports_1,
                  alt: _ctx.flagLabel,
                  width: "91",
                  height: "84"
                }, null, 8, ["alt"]))
              : (_openBlock(), _createBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode("span", {
                    class: ['cargo-flag-label', _ctx.labelClass]
                  }, _toDisplayString(_ctx.cargoFlagLabel), 3)
                ]))
          ], 64))
  ]))
})